// components/ProtectedRoute.js
import React from 'react';
import { Navigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requiredRoles = [], requireApproval = true }) => {
    const { user, loading, hasRole, isApproved } = useAuth();

    if (loading) {
        return (
            <div className="loading-container">
                <div className="spinner"></div>
                <p>Завантаження…</p>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (requiredRoles.length > 0 && !hasRole(requiredRoles)) {
        return (
            <div className="access-denied">
                <h2>Немає доступу</h2>
                <p className="muted-2">У тебе немає прав на цю сторінку.</p>
                <Link to="/dashboard">На огляд</Link>
            </div>
        );
    }

    if (requireApproval && !isApproved()) {
        return <Navigate to="/pending-approval" replace />;
    }

    return children;
};

export default ProtectedRoute;